import { useRef } from "react"

import {
  Dialog,
  Paper
} from "@mui/material"

import { styled } from "@mui/material/styles"

import Draggable from "react-draggable"

import "./HKVDialog.css"

const StyledPaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "dialogSize" && prop !== "scrollPaper",
})(({ theme, dialogSize }) => {
  const sizes = {
    xs: 440,
    sm: 660,
    md: 960,
    lg: 1260,
    xl: 1600,
    full: "100%"
  }
  const maxWidth = sizes[dialogSize] || 960

  return {
    display: "flex", flexDirection: "column",
    width: "100%",
    maxWidth: maxWidth,
    margin: theme.spacing(4),
    overflow: "hidden",
    [theme.breakpoints.down(maxWidth + 32)]: {
      margin: 0,
      maxHeight: "100%"
    },
    [theme.breakpoints.up(maxWidth + 32)]: {
      maxHeight: `calc(100% - ${theme.spacing(8)})`
    }
  }
})

const DraggablePaper = (props) => {
  const nodeRef = useRef(null)

  return <Draggable nodeRef={nodeRef} handle=".draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
    <StyledPaper
      {...props}
      ref={nodeRef}
      sx={{ ...props.sx, pointerEvents: "auto" }}
    >
      {props.children}
    </StyledPaper>
  </Draggable>
}

const StyledDialog = styled(Dialog)({
  "& .MuiDialog-container": {
    flexDirection: "column"
  }
})

function HKVDialog({ config, draggable, noPaper, onClose, children }) {
  if (!config) return null

  if (draggable) {
    const alignItems = {
      topLeft: "flex-start",
      topRight: "flex-end",
      bottomRight: "flex-end",
      bottomLeft: "flex-start"
    }

    const justifyContent = {
      topLeft: "flex-start",
      topRight: "flex-start",
      bottomRight: "flex-end",
      bottomLeft: "flex-end"
    }

    return (
      <StyledDialog
        open={config.open}
        onClose={(event, reason) => onClose && reason !== "backdropClick" ? onClose() : null}
        disableEnforceFocus
        disableRestoreFocus
        hideBackdrop
        maxWidth={false}
        slots={{
          paper: DraggablePaper
        }}
        slotProps={{
          container: {
            sx: {
              alignItems: alignItems[config.scrollPaper] || "flex-end",
              justifyContent: justifyContent[config.scrollPaper] || "flex-end",
            }
          },
          paper: {
            dialogSize: config.size
          }
        }}
        sx={{ pointerEvents: "none" }}
      >
        {children}
      </StyledDialog>
    )
  } else {
    return (
      <StyledDialog
        open={config.open}
        onClose={(event, reason) => onClose && reason !== "backdropClick" ? onClose() : null}
        disableRestoreFocus
        maxWidth={false}
        slots={{
          paper: noPaper ? "div" : StyledPaper
        }}
        slotProps={{
          paper: { dialogSize: config.size }
        }}
      >
        {children}
      </StyledDialog>
    )
  }
}

export default HKVDialog;
